import {
    BehaviorSubject
} from 'rxjs';

// import config from 'config';
import {
    requestOptions,
    handleResponse
} from '@/_helpers';

const getUserFromStorage = () => {
    const user = JSON.parse(localStorage.getItem('currentUser'));
    if (user && user.username === 'admin') {
        user.role = 'Admin';
        user.isAdmin = true;
    } else if (user) {
        user.role = 'User';
        user.isAdmin = false;
    }
    return user;
};

const currentUserSubject = new BehaviorSubject(getUserFromStorage());

export const authenticationService = {
    login,
    logout,
    currentUser: currentUserSubject.asObservable(),
    get currentUserValue() {
        return currentUserSubject.value;
    }
};

function login(username, password) {
    return fetch(`${process.env.VUE_APP_API}/api/users/authenticate`, requestOptions.post({
        username,
        password
    }))
        .then(handleResponse)
        .then(user => {
            if (username === 'admin') {
                user.role = 'Admin';
                user.isAdmin = true;
            } else {
                user.role = 'User';
                user.isAdmin = false;
            }
            
            // store user details and jwt token in local storage to keep user logged in between page refreshes
            localStorage.setItem('currentUser', JSON.stringify(user));
            localStorage.setItem('tenantId', user.tenantId);
            localStorage.setItem('selectedTenantId', user.tenantId);
            localStorage.setItem('selectedMpId', user.mpId);
            currentUserSubject.next(user);

            return user;
        });
}

function logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('currentUser');
    currentUserSubject.next(null);
}